import { apiSlice } from "../../app/api/apiSlice";

export const usageDashboardApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getUsage: builder.query({
            query: (params) => ({
                url: "/api/usage",
                params,
            }),
            providesTags: ["Usage"],
        })
    }),
});

export const {
    useGetUsageQuery,
} = usageDashboardApiSlice;
